module.exports = __webpack_public_path__ + "img/a3-s55.f27a2835.jpg";